module.exports = __webpack_public_path__ + "images/35b5fb71c38b946088feecc0c403825d2.svg";